<template>
  <div>
    <div class="ss-tim-navbar guide-step-popup-anchor1" :style="{ overflowX: 'auto' }" ref="navbar">
      <div class="tim-item" v-for="(item, index) in navArr" :key="index" @click="tabChange(index)">
        <div class="tim-title" :class="{ timcurrent: current == index }">
          {{ item.name }}
          <div class="red" v-if="item.isred"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabSwiperNav',
  props: {
    current: {
      type: [Number, String],
      default: 0
    },
    navArr: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      scrollLeft: 0,
      screenWidth: 0
    };
  },
  methods: {
    tabChange(index) {
      this.$emit("swiperNow", index);
    }
  }
};
</script>

<style lang="scss" scoped>
.ss-tim-navbar {
  white-space: nowrap;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;

  // @include ipad-or-above() {
  //   display: flex;
  //   justify-content: space-around;
  // }

  .tim-item {
    width: auto;
    padding: 0 1.65rem 2.25rem;
    height: 1.1rem;
    display: inline-block;
    text-align: center;
    border-radius: .55rem;
    opacity: 1;
    color: #666666;
    margin-top: .07rem;
    cursor: pointer;

    .tim-title {
      line-height: 1.1rem;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      font-size: .7rem;

      .red {
        width: .3rem;
        height: .3rem;
        background: #F04848;
        border-radius: 50%;
        position: absolute;
        top: .05rem;
        right: -0.2rem;
      }
    }
  }

  .timcurrent {
    font-weight: bold;
    position: relative;
    color: #000;
    font-size: .8rem !important;
    z-index: 2;
  }

  .timcurrent::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%);
    bottom: .15rem;
    opacity: 0.5;
    width: 100%;
    height: .2rem;
    background: #ffba1a;
    border-radius: 0;
  }
}

::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
  color: transparent;
}

.timcurrent {
  font-weight: bold;
  position: relative;
  color: #000;
  font-size: .8rem !important;
}

.timcurrent::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: .1rem;
  opacity: 0.5;
  width: 100%;
  height: .2rem;
  background: #ffba1a;
  border-radius: 0;
}
</style>